let cookieStateApplied = false // cookie massage applied
let cookieStateStats = false // cookies for stats like google analytics
let cookieStateAdds = false // cookies for marketing like facebook pixel
let cookieStateMedia = false // cookies for media like youtube, facebook, instagram
let cookieStateCommunication = false // cookies for communication

let cookieContent = document.getElementById('cookie-content') // cookie main content

let cookieButtonAccept = document.getElementById('cookie-button-accept') // cookie accept all
let cookieButtonIndividual = document.getElementById('cookie-button-individual') // cookie accept only checked
let cookieButtonDeny = document.getElementById('cookie-button-deny') // cookie accept only essential

let cookieButtonSettings = document.getElementById('cookie-button-settings') // show cookie content (again)
let cookieButtonIndividualSettings = document.getElementById('cookie-button-show-individual-settings') // show individual settings
let cookieIndividualSettings = document.getElementById('cookie-individual-settings') // cookie individual content

let inputSwitchStats = document.getElementById('switch-stats') // input tag stats
let inputSwitchAdds = document.getElementById('switch-adds') // input tag adds
let inputSwitchMedia = document.getElementById('switch-media') // input tag media
let inputSwitchCommunication = document.getElementById('switch-communication') // input tag media

/**
 * function set cookies for stats
 */
function setCookieStatsContent(apply) {
    console.log("setCookieStatsContent", apply)
    if (apply) {
        let script = document.createElement('script')
        script.src = 'https://www.googletagmanager.com/gtag/js?id=UA-27328049-6'
        script.async
        document.body.appendChild(script)

        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'UA-27328049-6', { 'anonymize_ip': true });

        window['ga-disable-=UA-27328049-6'] = false
        console.log('enable google analytics')
    } else {
        // OPT OUT - https://developers.google.com/analytics/devguides/collection/gtagjs/user-opt-out
        window['ga-disable-UA-27328049-6'] = true
        console.log('disable google analytics')
    }
}

/**
 * function set cookies for adds
 */
function setCookieAddsContent(apply) {
    console.log("setCookieAddsContent", apply)
}

/**
 * function set cookies for media
 */
function setCookieMediaContent(apply) {
    console.log("setCookieMediaContent", apply)
}

/**
 * function set cookies for communication
 */
function setCookieCommunicationContent(apply) {
    console.log("setCookieCommunicationContent", apply)
    if (apply) {
        let script = document.createElement('script')
        script.src = 'https://www.recaptcha.net/recaptcha/api.js'
        document.body.appendChild(script)
        console.log('enable google recaptcha')
    } else {
        let message = document.getElementById('cookie-communication-message')
        if(message) {
            message.innerHTML = "Sie müssen die Kommunikation-Cookies akzeptieren um eine Nachricht zu senden!"
        }
        console.log('disable google recaptcha')
    }
}

/**
 * save cookie decision to local storage
 */
function saveCookieDecisionToLocalStorage(stats, adds, media, communication) {
    localStorage.setItem('pixelparker_cookie_applied', JSON.stringify(true))

    if (stats) {
        localStorage.setItem('pixelparker_cookie_stats_accepted', JSON.stringify(true))
        setCookieStatsContent(true)
    } else {
        localStorage.setItem('pixelparker_cookie_stats_accepted', JSON.stringify(false))
    }

    if (adds) {
        localStorage.setItem('pixelparker_cookie_adds_accepted', JSON.stringify(true))
        setCookieAddsContent(true)
    } else {
        localStorage.setItem('pixelparker_cookie_adds_accepted', JSON.stringify(false))
    }

    if (media) {
        localStorage.setItem('pixelparker_cookie_media_accepted', JSON.stringify(true))
        setCookieMediaContent(true)
    } else {
        localStorage.setItem('pixelparker_cookie_media_accepted', JSON.stringify(false))
    }

    if (communication) {
        localStorage.setItem('pixelparker_cookie_communication_accepted', JSON.stringify(true))
        setCookieCommunicationContent(true)
    } else {
        localStorage.setItem('pixelparker_cookie_communication_accepted', JSON.stringify(false))
    }

    // refresh page and load plugins
    window.location.reload(true)
}

/**
 * init values if null
 */
function initValuesIfNull() {
    if (cookieStateApplied === null) {
        localStorage.setItem('pixelparker_cookie_applied', JSON.stringify(false))
        cookieStateApplied = false
        showHideCookieSettings()
    }
    if (cookieStateStats === null) {
        localStorage.setItem('pixelparker_cookie_stats_accepted', JSON.stringify(false))
        cookieStateStats = false
    }
    if (cookieStateAdds === null) {
        localStorage.setItem('pixelparker_cookie_adds_accepted', JSON.stringify(false))
        cookieStateAdds = false
    }
    if (cookieStateMedia === null) {
        localStorage.setItem('pixelparker_cookie_media_accepted', JSON.stringify(false))
        cookieStateMedia = false
    }
    if (cookieStateCommunication === null) {
        localStorage.setItem('pixelparker_cookie_communication_accepted', JSON.stringify(false))
        cookieStateCommunication = false
    }
    reactOnState()
}

/**
 * read and check cookie decision from local storage
 */
function readAndCheckCookieDecisionFromLocalStorage() {
    cookieStateApplied = localStorage.getItem('pixelparker_cookie_applied')
    cookieStateStats = (localStorage.getItem('pixelparker_cookie_stats_accepted') === 'true')
    cookieStateAdds = (localStorage.getItem('pixelparker_cookie_adds_accepted') === 'true')
    cookieStateMedia = (localStorage.getItem('pixelparker_cookie_media_accepted') === 'true')
    cookieStateCommunication = (localStorage.getItem('pixelparker_cookie_communication_accepted') === 'true')
    console.log("cookies: set_ ", cookieStateApplied, " stats_ ", cookieStateStats, " adds_ ", cookieStateAdds, " media_ ", cookieStateMedia, " media_ ", cookieStateCommunication)
    initValuesIfNull()
    setCookieStatsContent(cookieStateStats)
    setCookieAddsContent(cookieStateAdds)
    setCookieMediaContent(cookieStateMedia)
    setCookieCommunicationContent(cookieStateCommunication)
}

/**
 * show hide cookie Settings
 */
function showHideCookieSettings() {
    cookieContent.classList.toggle('d-flex')
    cookieContent.classList.toggle('d-none')
}

/**
 * react on state -> show or hide content
 */
function reactOnState() {
    //  set checked state on cookie individual parts (stats, adds, media)
    if (inputSwitchStats) {
        inputSwitchStats.checked = cookieStateStats
    }

    if (inputSwitchAdds) {
        inputSwitchAdds.checked = cookieStateAdds
    }

    if (inputSwitchMedia) {
        inputSwitchMedia.checked = cookieStateMedia
    }

    if (inputSwitchCommunication) {
        inputSwitchCommunication.checked = cookieStateCommunication
    }
}

/**
 * show or hide individual cookie settings
 */
function showHideIndividualSettings() {
    cookieIndividualSettings.classList.toggle('d-block')
    cookieIndividualSettings.classList.toggle('d-none')
}

/**
 * cookie button click event
 */
if (cookieButtonAccept) {
    cookieButtonAccept.addEventListener('click', function () {
        saveCookieDecisionToLocalStorage(true, true, true, true)
    })
}
if (cookieButtonIndividual && inputSwitchStats && inputSwitchAdds && inputSwitchMedia && inputSwitchCommunication) {
    cookieButtonIndividual.addEventListener('click', function () {
        saveCookieDecisionToLocalStorage(inputSwitchStats.checked, inputSwitchAdds.checked, inputSwitchMedia.checked, inputSwitchCommunication.checked)
    })
}
if (cookieButtonDeny) {
    cookieButtonDeny.addEventListener('click', function () {
        saveCookieDecisionToLocalStorage(false, false, false, false)
    })
}
if (cookieButtonSettings) {
    cookieButtonSettings.addEventListener('click', function () {
        showHideCookieSettings()
    })

}
if (cookieButtonIndividualSettings) {
    cookieButtonIndividualSettings.addEventListener('click', function () {
        showHideIndividualSettings()
    })
}

/**
 * document content loaded function
 */
document.addEventListener('DOMContentLoaded', function () {
    readAndCheckCookieDecisionFromLocalStorage()
})
